import React, { useState } from 'react'
import {v4 } from "uuid"
import {IoMdAdd} from "react-icons/io"
import {FiMinus} from "react-icons/fi"
import styles from "./education.module.css";
import {AiOutlineDown, AiOutlineRight} from "react-icons/ai"
import { updatePost } from '../../utils/Fetch/fetch';
import { toast } from 'react-toastify';
import Loader from '../Loader/loader';

const month = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const Education = () => {
    const [color, setColor] = useState(false)
    const [show, setShow] = useState(false)
    const [inputFields, setInputFields] = useState([
        {courseName : "", institute : "", from : "", to : "", check:false, id: v4()}
    ])
        const [showLoader, setShowLoader] = useState(false);

    const handleChangeInput = (id, event) => {
        console.log(typeof event.target.checked)
        let newInputs;
        if(event.target.type === "checkbox") {
            console.log("insode check")
            newInputs = inputFields.map((el) => {
                if(id === el.id) {
                    el[event.target.name] = event.target.checked;
                }
                return el
            })
        }
        // else if(event.target.type === "month"){

        //  newInputs = inputFields.map((el) => {
        //     if(id === el.id) {
        //         el[event.target.name] =   month[event.target.value.split("-")[1][1]];
        //     }
        //     return el
        // })
        // }
        else {
            newInputs = inputFields.map((el) => {
                if(id === el.id) {
                    el[event.target.name] = event.target.value;
                }
                return el
            })
        }

        setInputFields(newInputs)
        console.log(inputFields)
    }
    const handleAddInput = () => {
        if(inputFields.length > 2){
            toast("Sorry! maximum 3 educational data is allowed")
            return;
        }
        setInputFields([...inputFields, {courseName : "", institute : "", from : "", to : "", check: false, id: v4()}])
    }
    const handleMinusInput = (index) => {
        const values  = [...inputFields];
        values.splice(index, 1)
        setInputFields(values)
    }
    

    const handleSave = async ()=> {
      setShowLoader(true);
        let flag = false
        inputFields.forEach((el) => {
          if(el.courseName==="" || el.institute==="" || el.from===""){
            flag = true;
          }
          if(el.to === "" && el.check===false){
            flag=true
          }
        })

        if(flag){
          toast("Please fill the empty educational data")
          setColor(false)
          setShowLoader(false);
          return;
        }
        let payload = inputFields.map((el) => {
          return {coursename : el.courseName, institute: el.institute, from: `${month[el.from.split("-")[1][1]]} ${el.from.split("-")[0]}`, to:el.check===true?"Present":`${month[el.to.split("-")[1][1]]} ${el.to.split("-")[0]}`}
        })
        const updatedata = async () => {
          let data = await updatePost(JSON.stringify({education: payload}))
          return data;
        }
  
        let updatedData = await updatedata()
  
        if(updatedData.success===true){
          toast("Educational data is saved successfully!")
          setColor(true)
          setShow(false)
          setShowLoader(false);
        }else {
          toast("Something went wrong!")
          setShowLoader(false);
        }
  
  
  
      }



  return (
    <div>
      <nav className={styles.profile__nav} onClick={() => setShow(!show)}>
        <h3 style={{color : color===false ? "crimson" : 'grey'}}>
          Educational Details (max:3)</h3>
        <span>
          {show ? <span className={styles.updown__icon}><AiOutlineDown/></span> : <span className={styles.updown__icon}><AiOutlineRight/></span>}
        </span>
      </nav>

        {
            show && <div className={styles.input__box}>
            {inputFields.map((input, index) => (
                <div key={input.id} className={styles.inputs}>
                
                <div>
                <label htmlFor="courseName">Course Name</label>
                <input type="text"name='courseName'id="courseName" value={input.courseName} placeholder="Course name" 
                onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>

                <div>
                <label htmlFor="institute">Institute/University</label>
                <input type="text" name='institute' id="institute"value={input.institute} placeholder="Institute/University"
                onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>

                <div>
                <label htmlFor='from'>Start Date</label>
                <input type="month" id="from" name="from"  placeholder="Start date" 
                onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>

                {
                    input.check===false && <div> 
                    <label htmlFor="to">End Date</label>
                    <input type="month" name='to' id="to" placeholder="End date"
                    onChange={(event) => handleChangeInput(input.id, event)}/>
                    </div>
                }

                <div>
                <label>Currently studying</label>
                <input type="checkbox" value={input.check} name="check"  onChange={(event) => handleChangeInput(input.id, event)}/>
                </div>
                
                <div>
                <button onClick={() => handleAddInput()}>
                <IoMdAdd />
                </button>
                {
                    index >= 1 && <button style={{marginLeft:"5px"}} onClick={() => handleMinusInput(index)}>
                        <FiMinus />
                    </button>
                }
                </div>
                </div>
            ))
            }

                <div className={styles.savebtn_box}>
                <button onClick={handleSave}>Save</button>
                </div>
            </div>
        }
  {showLoader && <Loader /> }
    </div>
  )
}

export default Education